<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="450px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div *transloco="let t" class="xi-modal__container">
          <h2 class="xi-modal__title">{{ t('widgets.sentiment-filter-title') }}</h2>

          <div class="xi-modal__content">
            <div class="filter-header">{{ t('widgets.sentiment-filter-content') }}</div>

            <ul class="radio-group">
              @for (polarity of sentimentFilterPolarities; track polarity) {
                <li class="radio-button">
                  <xi-checkbox
                    color="CX"
                    [label]="polarity.value"
                    [(ngModel)]="polarity.checked"
                  ></xi-checkbox>
                </li>
              }
            </ul>
          </div>

          <div class="xi-modal__actions widget-sentiment-filter__actions">
            <xi-default-button
              [text]="t('widgets.cancel')"
              fill="text"
              (onClick)="cancel()"
            ></xi-default-button>

            <xi-default-button
              [text]="t('widgets.save')"
              [disabled]="isSaveDisabled"
              (onClick)="save()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
